export const ORDER_STATUS: Record<TGroupGiftOrderStatus, { label: string; color: string }> = {
  CONFIRMED: { label: '주문 확정', color: '#3478f6' },
  DELIVERING: { label: '배송중', color: '#46b476' },
  DELIVERED: { label: '배송완료', color: '#212529' }
};

// 단체선물대장 공급처 주문 상태
export type TGroupGiftOrderStatus = 'CONFIRMED' | 'DELIVERING' | 'DELIVERED';

// 조회 기간 기준 날짜 (CONFIRM_DATE:주문확정일, REQUEST_SHIPMENT_DATE:출고희망일)
export type TGroupGiftDateType = 'CONFIRM_DATE' | 'REQUEST_SHIPMENT_DATE';

// 송장 등록 여부
export type TGroupGiftTrackingStatus = 'ALL' | 'REGISTERED' | 'UNREGISTERED';

// 키워드 검색 대상
export type TGroupGiftKeywordType = 'RECEIVER_NAME' | 'TRACKING_NUMBER' | 'ORDER_NO';

// 단체선물대장 공급처 주문 목록 조회 파라미터
export interface IGroupGiftOrdersParams {
  page?: number;
  size?: number;
  dateType?: TGroupGiftDateType;
  startDate?: string;
  endDate?: string;
  orderStatuses?: TGroupGiftOrderStatus[];
  trackingStatus?: TGroupGiftTrackingStatus;
  keywordType?: TGroupGiftKeywordType;
  keyword?: string;
}

// 단체선물대장 공급처 주문 단건
export interface IGroupGiftOrder {
  groupGiftOrderIdx: number;
  companyName: string;
  productCode: string;
  productName: string;
  productOption: string;
  status: TGroupGiftOrderStatus;
  receiverName: string;
  receiverPhone: string;
  receiverZipCode: string;
  receiverRoadAddress: string;
  receiverJibunAddress: string;
  receiverAddressDetail: string;
  confirmDate: string;
  requestShipmentDate: string;
  deliveryRequirement: string;
  logisticsCode: string;
  logisticsName: string;
  trackingNumber: string;
  supplyPrice: number;
  companyRequirement: string;
  senderName: string;
  senderRoadAddress: string;
  senderJibunAddress: string;
  senderAddressDetail: string;
  senderZipCode: string;
}

// 단체선물대장 공급처 주문 목록 조회 응답
export interface IGroupGiftOrdersResponse {
  totalCount: number;
  confirmedCount: number;
  deliveringCount: number;
  deliveredCount: number;
  content: IGroupGiftOrder[];
}
